import React, { useState, useCallback } from "react";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import SelectItem from "../selectItem";
import InputNumberItem from "../inputNumberItem";

function NumberWithCurrency({
  label,
  error,
  message,
  disabled,
  precision,
  thirdItem,
  maxAmount,
  className,
  amountSpan,
  currencies,
  amountOffset,
  currencySpan,
  onInputChange,
  onSetCurrency,
  initialAmount,
  optionalAmount,
  formItemLayout,
  amountClassName,
  initialCurrency,
  amountFieldName,
  currencyFieldName,
  currencyClassName,
  getFieldDecorator,
  disableCurrencySet,
}) {
  const intl = useIntl();
  const [selectedCurrencyId, setSelectedCurrencyId] = useState(
    initialCurrency ||
      (disableCurrencySet
        ? currencies.find((c) => c.code === "CZK").id
        : currencies[0].id)
  );
  const handleCurrencySelect = useCallback(
    (id) => {
      onSetCurrency && onSetCurrency(currencies.find((c) => c.id === id));
      setSelectedCurrencyId(id);
    },
    [currencies, onSetCurrency]
  );

  return (
    <Row className={className}>
      <Col
        offset={amountOffset}
        span={amountSpan || 8}
        className={amountClassName}
      >
        <InputNumberItem
          error={error}
          label={label}
          labelCol={15}
          wrapperCol={9}
          max={maxAmount}
          message={message}
          disabled={disabled}
          precision={precision}
          optional={optionalAmount}
          fieldName={amountFieldName}
          initialValue={initialAmount}
          onInputChange={onInputChange}
          formItemLayout={formItemLayout}
          getFieldDecorator={getFieldDecorator}
        />
      </Col>
      <Col span={currencySpan || 4} className={currencyClassName}>
        {selectedCurrencyId && (
          <SelectItem
            useCode
            wrapperCol={13}
            allowClear={false}
            options={currencies}
            fieldName={currencyFieldName}
            message={intl.formatMessage({
              id: "consignment.services.chooseCurrency",
              defaultMessage: "Vyberte prosím měnu!",
            })}
            onSelect={handleCurrencySelect}
            formItemLayout={formItemLayout}
            initialValue={selectedCurrencyId}
            getFieldDecorator={getFieldDecorator}
            disabled={disableCurrencySet || disabled}
          />
        )}
      </Col>
      {thirdItem && <Col span={2}>{thirdItem}</Col>}
    </Row>
  );
}

export default NumberWithCurrency;
